import { useCallback, useState } from 'react';

/**
 * The trainee's currently-open tree (by plan code), persisted to localStorage so the
 * Development Plan tab and the Games tab agree on which tree is active. View-layer
 * only (mirrors useDevTabsAccess) — not redux. `null` = no tree selected → the picker.
 */
const KEY = 'vega.devplan.activePlan';

export function useActivePlan(): [string | null, (code: string | null) => void] {
  const [code, setCode] = useState<string | null>(() => {
    try {
      return window.localStorage.getItem(KEY);
    } catch {
      return null;
    }
  });

  const set = useCallback((next: string | null) => {
    setCode(next);
    try {
      if (next) window.localStorage.setItem(KEY, next);
      else window.localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  }, []);

  return [code, set];
}

export default useActivePlan;
